<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="block block-rounded" :class="{ 'block-mode-loading': loading || !userApiToken }">
          <div class="block-content text-center bg-gd-primary">
            <p class="text-white text-uppercase font-size-sm font-w700">
              {{$t('home.stats.dataProcessor')}}
            </p>
          </div>
          <div class="block-content block-content-full">
            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                  <div>
                    <i class="fa fa-2x fa-sync-alt fa-spin text-primary"></i>
                  </div>
                  <div class="ml-3 text-right">
                    <span class="text-muted font-3w00 mb-0 mr-1">{{$t('home.stats.blocksProcessed')}} </span><span v-text="numbro(stats.latest_block.block_num).format('0,0')" class="font-size-h3 font-w700 mb-0"></span>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                  <div class="mr-3 text-left">
                    <span v-text="moment(stats.latest_block.time).format('MMM Do YYYY - h:mm:ss a')" class="font-size-h3 font-w700 mb-0"></span>
                  </div>
                  <div>
                    <i class="fa fa-2x fa-clock text-primary"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                  <div>
                  </div>
                  <div class="ml-3 text-right">
                    <span class="text-muted font-w300 mb-0 mr-1">{{$t('home.stats.blocksOnChain')}} </span><span v-text="numbro(eosChainInfo.last_irreversible_block_num).format('0,0')" class="font-size-h3 font-w700 mb-0"></span>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                  <div class="mr-3 text-left">
                    <span class="font-size-h3 font-w700 mb-0">{{blocksDelta}}</span><span class="text-muted font-w300 mb-0 ml-1"> {{$t('home.stats.unprocessedBlocks')}}</span>
                  </div>
                  <div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-xl-6">
        <div class="block block-rounded" :class="{ 'block-mode-loading': loading || !userApiToken }">
          <div class="block-content text-center bg-gd-primary">
            <p class="text-white text-uppercase font-size-sm font-w700">
              {{$t('home.stats.totalTransfers')}}
            </p>
          </div>
          <div class="block-content block-content-full d-flex align-items-center justify-content-between">
            <div>
              <font-awesome-icon icon="exchange-alt" fixed-width class="fa-2x text-primary"/>
            </div>
            <div class="ml-3 text-right">
              <p v-text="numbro(stats.total_transfers).format('0.0a')" class="font-size-h3 font-w300 mb-0"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-xl-6">
        <div class="block block-rounded" :class="{ 'block-mode-loading': loading || !userApiToken }">
          <div class="block-content text-center bg-gd-primary">
            <p class="text-white text-uppercase font-size-sm font-w700">
              {{$t('home.stats.totalAccounts')}}
            </p>
          </div>
          <div class="block-content block-content-full d-flex align-items-center justify-content-between">
            <div>
              <i class="fa fa-2x fa-user-circle text-primary"></i>
            </div>
            <div class="ml-3 text-right">
              <p v-text="numbro(stats.total_accounts).format('0,0')" class="font-size-h3 font-w300 mb-0"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiCall from '@/api/eos-detective'
import numbro from 'numbro'
import moment from 'moment'
import VueTimers from 'vue-timers/mixin'

const EosApi = require('eosjs-api')

const eos = EosApi({ httpEndpoint: 'https://api.eosn.io' })
const bos = EosApi({ httpEndpoint: 'https://bos.eosn.io/' })
const wax = EosApi({ httpEndpoint: 'https://wax.eosn.io/' })

export default {
  name: 'stats',
  mixins: [VueTimers],
  timers: {
    getStats: { time: 3000, autostart: true, repeat: true },
    getEOSChainInfo: { time: 2000, autostart: true, repeat: true }
  },
  data () {
    return {
      moment: moment,
      numbro: numbro,
      loading: false,
      stats: {
        total_transfers: 0,
        total_accounts: 0,
        latest_block: {
          block_num: 0,
          time: '0'
        }
      },
      eosChainInfo: {
        last_irreversible_block: 0
      }
    }
  },
  computed: {
    blocksDelta () {
      return numbro(this.eosChainInfo.last_irreversible_block_num - this.stats.latest_block.block_num).format('0,0')
    },
    selectedChain () {
      return this.$store.state.options.selectedChain
    },
    userApiToken () {
      return this.$store.state.auth.profile.userApiToken
    }
  },
  created () {
    this.loading = true
    this.getStats()
    this.getEOSChainInfo()
  },
  methods: {
    getEOSChainInfo () {
      if (this.selectedChain === 'eos') {
        eos.getInfo({})
          .then((data) => {
            this.eosChainInfo = data
          })
      }
      if (this.selectedChain === 'bos') {
        bos.getInfo({})
          .then((data) => {
            this.eosChainInfo = data
          })
      }
      if (this.selectedChain === 'wax') {
        wax.getInfo({})
          .then((data) => {
            this.eosChainInfo = data
          })
      }
    },
    getStats () {
      apiCall({
        apiToken: this.userApiToken,
        endpoint: 'stats',
        params: {
          chain: this.selectedChain
        }
      })
        .then((response) => {
          this.stats = response
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  },
  watch: {
    userApiToken () {
      this.getStats()
    }
  }
}
</script>

<style scoped>

</style>
